module.exports = __webpack_public_path__ + "img/shoplogo.f2298094.png";